import {
    ListOrdered,
    Gauge,
    Wrench,
    ScrollText,
    Cog,
    ArrowLeftRight,
    FileText,
    FlaskConical,
    Rocket,
    Play,
    Factory,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useLanguage } from "@/i18n";

const ICONS = [ListOrdered, Gauge, Wrench, ScrollText, Cog, ArrowLeftRight, FileText, FlaskConical, Rocket, Play];

export default function MesSection() {
    const { t } = useLanguage();

    return (
        <section id="mes" data-testid="mes-section" className="relative scroll-mt-20 border-y border-navy-600 bg-navy-900">
            <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-2 lg:px-10 lg:py-32">
                <div>
                    <SectionHeading
                        chapter={t.mes.chapter}
                        eyebrow={t.mes.eyebrow}
                        title={t.mes.title}
                        testid="mes-heading"
                    />
                    <Reveal delay={0.1}>
                        <p className="text-base leading-relaxed text-slate-400 sm:text-lg">{t.mes.text}</p>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <div
                            data-testid="mes-motis-card"
                            className="mt-8 border-l-2 border-sky-400 bg-navy-950 p-6"
                        >
                            <div className="flex items-center gap-3">
                                <Factory className="h-5 w-5 text-sky-400" />
                                <span className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-400">
                                    {t.mes.motisLabel}
                                </span>
                            </div>
                            <p className="mt-4 text-sm leading-relaxed text-slate-300 sm:text-base">
                                {t.mes.motisA}
                                <strong className="font-semibold text-slate-50">MOTIS MES</strong>
                                {t.mes.motisB}
                            </p>
                        </div>
                    </Reveal>
                </div>

                <div className="grid content-start gap-px border border-navy-600 bg-navy-600 sm:grid-cols-2">
                    {t.mes.items.map((a, i) => {
                        const Icon = ICONS[i];
                        return (
                            <Reveal key={i} delay={i * 0.04} className="h-full">
                                <div
                                    data-testid={`mes-activity-${i + 1}`}
                                    className="group flex h-full items-start gap-4 bg-navy-950 p-4 transition-colors hover:bg-navy-800"
                                >
                                    <Icon className="mt-0.5 h-5 w-5 shrink-0 text-sky-400" />
                                    <div>
                                        <p className="font-mono text-[10px] tracking-widest text-slate-600">
                                            M.{String(i + 1).padStart(2, "0")}
                                        </p>
                                        <p className="mt-1 text-sm font-medium leading-snug text-slate-100">{a}</p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
